<template>
    <div class="horizontal grow" >
		<div v-if="data.status == 2 || place == 'PROBLEMS'" style="cursor: pointer; margin: 5px" @click="show(data, 'SOLUTIONS')" class="button-template" :content="$t('Solutions')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8751 5.66694C15.333 5.59992 14.7798 5.64004 14.2478 5.7885C13.4151 6.02087 12.6755 6.50706 12.1321 7.17942C11.5886 7.85178 11.2684 8.67684 11.2158 9.53976C11.1635 10.3988 11.379 11.2528 11.8326 11.984C11.9873 12.2208 11.9536 12.537 11.747 12.7358L7.17779 17.1342C6.97621 17.3667 6.87258 17.6686 6.88928 17.9763C6.90633 18.2906 7.04748 18.5852 7.28171 18.7955C7.51594 19.0057 7.82407 19.1143 8.13836 19.0975C8.44611 19.0809 8.73511 18.9454 8.94451 18.72L12.8256 13.7038C13.0021 13.4757 13.3148 13.4093 13.5667 13.5392C14.3417 13.9104 15.2129 14.0324 16.0602 13.888C16.9125 13.7429 17.6983 13.3357 18.3082 12.723C18.9182 12.1104 19.322 11.3228 19.4634 10.4699C19.5537 9.92499 19.534 9.37074 19.4091 8.83895L17.1306 11.3774C16.998 11.5251 16.8004 11.5968 16.604 11.5684L14.4858 11.2624C14.2486 11.2281 14.0553 11.0546 13.9957 10.8225L13.4635 8.74948C13.4141 8.55725 13.4641 8.35307 13.5967 8.20537L15.8751 5.66694ZM13.4838 14.7932C14.3666 15.1246 15.3243 15.2177 16.2595 15.0584C17.3552 14.8718 18.3654 14.3482 19.1495 13.5606C19.9337 12.773 20.4528 11.7605 20.6346 10.6641C20.8163 9.56762 20.6517 8.44178 20.1637 7.44326C20.0945 7.30181 19.972 7.19362 19.8231 7.1425C19.6742 7.09138 19.5111 7.10151 19.3696 7.17067C19.3011 7.20419 19.2393 7.25077 19.1883 7.30757L16.4593 10.348L15.0472 10.144L14.6923 8.76196L17.4214 5.72156C17.4716 5.66558 17.5107 5.60056 17.5367 5.52996C17.5913 5.38166 17.5845 5.21743 17.5178 5.07419C17.4511 4.93094 17.3301 4.8202 17.1815 4.7665C16.1362 4.38875 14.9992 4.34628 13.9287 4.645C12.8582 4.94373 11.9074 5.56878 11.2088 6.43315C10.5101 7.29753 10.0984 8.35821 10.0308 9.46757C9.97311 10.4145 10.1687 11.3567 10.5932 12.1986L6.33715 16.2956C6.32666 16.3057 6.31655 16.3161 6.30684 16.327C5.88663 16.7957 5.66973 17.4121 5.70384 18.0406C5.73794 18.6692 6.02025 19.2585 6.48871 19.679C6.95717 20.0994 7.57343 20.3167 8.20201 20.2829C8.83059 20.2492 9.42004 19.9672 9.84079 19.499C9.85052 19.4882 9.85984 19.477 9.86875 19.4655L13.4838 14.7932Z" fill="#346F8B"/>
            </svg>
        </div>
        <div v-if="(data.status == 2 || place == 'PROBLEMS') && data.filledPercent == 100" style="cursor: pointer; margin: 5px" @click="show(data, 'REPORT')" class="button-template" :content="$t('Report')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <img src="../../assets/img/Visits/Download.svg">
        </div>
        <div v-else-if="data.status == 0" style="cursor: pointer; margin: 5px" @click="show(data, 'PENDING')" class="button-template" :content="$t('PendingProblems')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <img src="../../assets/img/Visits/PendingProblems.svg">
        </div>
        <div v-else-if="data.status == 1" style="cursor: pointer; margin: 5px" @click="show(data, 'ACTIVE')" class="button-template" :content="$t('ActiveProblems')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <img src="../../assets/img/Visits/ActiveProblems.svg">
        </div>
        <div v-if="place != 'VISITS'" style="cursor: pointer; margin: 5px" @click="show(data, 'INFO')" class="button-template" :content="$t('MoreInfo')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <img src="../../assets/img/Visits/info.svg"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {},
        place: {
            default: 'VISITS',
            type: String,
            required: false
        }
    },
    data() {
        return {
            data: {},
            hoverProblems: false,
        }
    }
}
</script>

<style>
    .tippy-tooltip.customTheme-theme {
      background-color: #346F8B;
    }

    .tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
      border-left: 8px solid #346F8B;
    }
</style>



// WEBPACK FOOTER //
// src/components/Visits/VisitTableButtons.vue